import React from 'react';
import { Table, TableProps } from '@otp/ui';
import { getTableConfig } from './config';
import { useTranslation } from 'react-i18next';
import { LoginRuleCriteria } from 'src/components/login-rules/form/types';
import { LoginRuleCriteriaAction } from 'src/components/login-rules/form/login-rule-criteria/table/columns/actions/actions-modals';
import { useLoginRuleUserPoolFields } from 'src/hooks/query/login-rules/use-login-rule-user-pool-fields';

type LoginRuleCriteriaTableProps = Omit<TableProps, 'columns'> & {
  className?: string;
  data: Array<LoginRuleCriteria>;
  onActionFinished?: (
    action: LoginRuleCriteriaAction,
    { data, index }: { data: LoginRuleCriteria; index: number },
  ) => void;
};

export const LoginRuleCriteriaTable = ({
  data,
  className,
  options,
  onActionFinished,
  ...props
}: LoginRuleCriteriaTableProps) => {
  const { t } = useTranslation();
  const { data: loginRuleUserPoolFieldData, loading } =
    useLoginRuleUserPoolFields();

  const tableConfig = getTableConfig(data, {
    t,
    onActionFinished,
    data: loginRuleUserPoolFieldData,
  });

  return (
    <div className={className}>
      <Table options={options} {...props} data={data} columns={tableConfig} />
    </div>
  );
};
